import "../styles/genAIJobRoles.css";
import {
  FaChartBar,
  FaBriefcase,
  FaFileExcel,
  FaClipboardList,
  FaCogs,
  FaDatabase
} from "react-icons/fa";

export default function DataAnalyticsJobRoles() {
  const roles = [
    { title: "Data Analyst (Junior)", icon: <FaChartBar /> },
    { title: "Business Analyst", icon: <FaBriefcase /> },
    { title: "Excel / MIS Executive", icon: <FaFileExcel /> },
    { title: "Reporting Analyst", icon: <FaClipboardList /> },
    { title: "Operations Analyst", icon: <FaCogs /> },
    { title: "Data Support / Analytics Executive", icon: <FaDatabase /> }
  ];

  return (
    <section className="genai-roles-page">
      <div className="roles-container">

        {/* HEADER */}
        <div className="roles-header">
          <h2>
            Program Key <span>Job Roles</span>
          </h2>
          <p>
            Career opportunities after completing the
            <strong> Data Analytics Starter Program</strong>
          </p>
        </div>

        {/* ROLES GRID */}
        <div className="roles-grid">
          {roles.map((role, index) => (
            <div className="role-card" key={index}>
              <div className="role-icon">{role.icon}</div>
              <h4>{role.title}</h4>
            </div>
          ))}
        </div>

      </div>
    </section>
  );
}
